import { LINKS_FILTER_FULL_TEXT } from '@monash/portal-frontend-common';
import { generalFirstThenAlphabetical } from './get-dropdown-filter-list';
import c from '../category-new.module.scss';

const convertToDropdownItem = (filter) => {
  const title = LINKS_FILTER_FULL_TEXT[filter];
  const isTopLevel = filter.includes('GENERAL');

  if (isTopLevel) {
    const shortenedTitle = title.split('-')?.[0]?.trim();
    return { text: shortenedTitle, value: filter };
  } else {
    const shortenedTitle = title.split('-')?.[1]?.trim();
    const includeCountry =
      title.includes('International') || title.includes('Domestic');

    return {
      text: (
        <span className={c.withListDot}>
          {includeCountry ? title : shortenedTitle}
        </span>
      ),
      value: filter,
    };
  }
};

export const getDropdownFilterListForDesktop = (filters) => {
  const topLevelsSet = new Set(filters.map((filter) => filter.split('_')[0]));
  const topLevels = Array.from(topLevelsSet);

  return topLevels.map((topLevel) => {
    const filtersByTopLevel = filters.filter((filter) =>
      filter.startsWith(topLevel)
    );
    const generalFilterValue = `${topLevel}_GENERAL`;

    // Add the general filter if it doesn't exist
    const filterValuesWithGeneral = filtersByTopLevel.includes(
      generalFilterValue
    )
      ? filtersByTopLevel
      : [generalFilterValue, ...filtersByTopLevel];

    const sortedFilters = filterValuesWithGeneral.sort(
      generalFirstThenAlphabetical
    );
    const accordionItems = sortedFilters.map(convertToDropdownItem);
    const accordionTitle =
      LINKS_FILTER_FULL_TEXT[generalFilterValue].split(' - ')[0];

    return {
      accordionTitle,
      items: accordionItems,
    };
  });
};
